import { ref } from 'vue'
import {
  DATE_PRESETS,
  isInDateRange,
  monthsAgoInputDate,
  rangeFromPreset,
  toInputDate,
  type DatePresetKey,
} from '@/utils/dateInput'

/** 목록 화면 공통 기간 필터. 기본 3개월. */
export function useListDateRange(defaultPreset: DatePresetKey = '3m') {
  const initial = rangeFromPreset(defaultPreset)
  const fromDate = ref(initial.from || monthsAgoInputDate(3))
  const toDate = ref(initial.to || toInputDate())
  const preset = ref<DatePresetKey>(defaultPreset)

  function applyPreset(key: DatePresetKey) {
    preset.value = key
    const next = rangeFromPreset(key)
    fromDate.value = next.from
    toDate.value = next.to
  }

  function onManualDateChange() {
    preset.value = 'all'
  }

  function inRange(dateStr: string | null | undefined) {
    return isInDateRange(dateStr, fromDate.value, toDate.value)
  }

  return {
    fromDate,
    toDate,
    preset,
    presets: DATE_PRESETS,
    applyPreset,
    onManualDateChange,
    inRange,
  }
}
